import React, { useState } from "react";
import Header from "../Componant/Header";
import Sidebar from "../Componant/Sidebar";
import InboxData from "../InboxManagement/InboxData";
import DashboardData from "./DashboardData";
import ContactData from "../Contacts/ContactData";
import SettingsData from "../Settings/SettingsData";
import { Container, Offcanvas } from "react-bootstrap";
import ProfileManagement from "../ProfileManagement/ProfileManagement";
import Accessibility from "../Accessibility/Accessibility";
import { useApp } from "../../APIHelpers/AppContext";
import SEOManagement from "../SEOManagement/SEOManagement";
import AdminAudioCallManager from "../../CallPopups/AdminAudioCallManager";

const ADMIN_SOCKET_ID = "admin";
const ADMIN_SOCKET_NAME = "Admin";

const Dashboard = () => {
  const [showSidebar, setShowSidebar] = useState(false);
  const [openModule, setOpenModule] = useState("dashboard");
  const {
    getCurrectLoginUser,
    currentUserData,
    getSinglePlateformSettings,
    plateformSettings,
    getOrganizations,
    organizationList,
  } = useApp();

  return (
    <>
      <Header
        onMenuClick={() => setShowSidebar(true)}
        setOpenModule={setOpenModule}
        openModule={openModule}
        currentUserData={currentUserData}
        getCurrectLoginUser={getCurrectLoginUser}
        getSinglePlateformSettings={getSinglePlateformSettings}
        plateformSettings={plateformSettings}
      />

      <AdminAudioCallManager
        adminUserId={ADMIN_SOCKET_ID}
        adminName={ADMIN_SOCKET_NAME}
      />

      <Offcanvas
        show={showSidebar}
        onHide={() => setShowSidebar(false)}
        className="d-md-none"
      >
        <Offcanvas.Header closeButton>
          <img
            src="https://tawk.link/5edc81e54a7c6258179a1405/var/logo/u30481uPlW.png?width=40&height=40"
            alt="logo"
            style={{ width: 28 }}
            className="me-2"
          />
          <div className="position-relative" style={{ lineHeight: 1.2 }}>
            <p className="m-0 brand-text fw-bold">
              {currentUserData?.loginPropertyName}
            </p>
            <p className="m-0 brand-text" style={{ fontSize: 10 }}>
              {currentUserData?.loginAccountName}
            </p>
          </div>
        </Offcanvas.Header>
        <Offcanvas.Body className="p-0">
          <Sidebar
            setOpenModule={setOpenModule}
            openModule={openModule}
            setShowSidebar={setShowSidebar}
            showSidebar={showSidebar}
          />
        </Offcanvas.Body>
      </Offcanvas>

      <Container fluid className="dashboard-container p-0">
        <div className="d-flex">
          <div className="d-none d-md-block">
            <Sidebar
              setOpenModule={setOpenModule}
              openModule={openModule}
              setShowSidebar={setShowSidebar}
              showSidebar={showSidebar}
            />
          </div>

          {openModule === "dashboard" && (
            <DashboardData
              openModule={openModule}
              currentUserData={currentUserData}
            />
          )}

          {openModule === "inbox" && (
            <InboxData
              category="inbox"
              currentUserData={currentUserData}
              openModule={openModule}
            />
          )}

          {openModule === "monitoring" && (
            <InboxData
              category="visitor"
              currentUserData={currentUserData}
              openModule={openModule}
            />
          )}

          {openModule === "activeChats" && (
            <InboxData
              openModule={openModule}
              category="activeChat"
              currentUserData={currentUserData}
            />
          )}

          {openModule === "contacts" && (
            <ContactData currentUserData={currentUserData} />
          )}

          {openModule === "seo_management" && <SEOManagement />}

          {openModule === "settings" && (
            <SettingsData
              getCurrectLoginUser={getCurrectLoginUser}
              currentUserData={currentUserData}
            />
          )}

          {openModule === "accessibility" && (
            <Accessibility
              getOrganizations={getOrganizations}
              organizationList={organizationList}
              currentUserData={currentUserData}
              getCurrectLoginUser={getCurrectLoginUser}
            />
          )}

          {openModule === "profileManagement" && (
            <ProfileManagement
              getCurrectLoginUser={getCurrectLoginUser}
              currentUserData={currentUserData}
            />
          )}
        </div>
      </Container>
    </>
  );
};

export default Dashboard;